import { useDispatch } from "react-redux";
import {
  storeCoreUiSelectTheme,
  storeCoreUiSetLayout,
} from "../datasources/_coreui.layout.store.slice";
import { useCoreUiTypedSelector } from "../../../configs/_coreui.store.slice";

export const useCoreUiThemeSwitcher = () => {
  const dispatch = useDispatch();
  const theme = useCoreUiTypedSelector(storeCoreUiSelectTheme);

  theme === "dark"
    ? document.body.classList.add("dark-theme")
    : document.body.classList.remove("dark-theme");

  const setLightTheme = () => {
    dispatch(storeCoreUiSetLayout({ theme: "light" }));
  };

  const setDarkTheme = () => {
    dispatch(storeCoreUiSetLayout({ theme: "dark" }));
  };

  return {
    state: { theme },
    action: { setLightTheme, setDarkTheme },
  };
};
